





























































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import times from 'lodash.times'
import sortBy from 'lodash.sortby'
import uniqBy from 'lodash.uniqby'
import Onsya from 'onsya'
import presets from './presets'
import { generateVocable, vocableToString } from './vocable'
import FilterIcon from 'vue-material-design-icons/FilterOutline.vue'
import CopyIcon from 'vue-material-design-icons/ContentCopy.vue'
import PasteIcon from 'vue-material-design-icons/ContentPaste.vue'

interface IWord {
  vocable: string
  sound: string
}

interface IItem {
  id: number,
  key: string
  value: string
  label: string
}

function isSafe<T> (item: T | undefined): item is T {
  return item !== undefined
}

@Component({
  components: {
    FilterIcon,
    CopyIcon,
    PasteIcon,
  },
})
export default class App extends Vue {
  public version = 2
  public serialized: string = ''

  public words: IWord[] = []
  public edit = false

  public onsets: IItem[][] = [[], [], [], [], [], [], [], [], [], []]
  public nuclea: IItem[][] = [[], [], [], [], [], [], [], [], [], []]
  public codas: IItem[][] = [[], [], [], [], [], [], [], [], [], []]
  public onsetQuery = ''
  public nucleusQuery = ''
  public codaQuery = ''
  public activeIndex = 0
  public numOfSyllables: number = 1
  public onsetConsonantBlending: number = 1
  public codaConsonantBlending: number = 1
  public copyContent: {
    onsets: IItem[],
    nuclea: IItem[],
    codas: IItem[],
  } | null = null

  public mounted () {
    const query = location.search.substring(1)
    if (query) {
      const {
        onsets, nuclea, codas,
      } = this.deserialize(query)
      this.numOfSyllables = onsets.length
      this.onsets = [...onsets, ...this.onsets]
      this.nuclea = [...nuclea, ...this.nuclea]
      this.codas = [...codas, ...this.codas]
      this.serialized = query
    } else {
      this.edit = true
    }
  }

  public get url () {
    return `https://eure.mobi/fantasy-name-generator/?${this.serialized}`
  }

  public serialize (onsets: IItem[][], nuclea: IItem[][], codas: IItem[][], numOfSyllables: number) {
    return [
      onsets.slice(0, numOfSyllables)
        .map((onset) => onset.map(({ id }) => (0 + id.toString(36)).slice(-2) ).join(''))
        .join('-'),
      nuclea.slice(0, numOfSyllables)
        .map((nucleus) => nucleus.map(({ id }) => (0 + id.toString(36)).slice(-2)).join(''))
        .join('-'),
      codas.slice(0, numOfSyllables)
        .map((coda) => coda.map(({ id }) => (0 + id.toString(36)).slice(-2)).join(''))
        .join('-'),
    ].join(',')
  }

  public deserialize (serialized: string) {
    const [onsets, nuclea, codas] = serialized.split(',')
    return {
      onsets: onsets.split('-').map((onset) => {
        return onset.split(/(.{2})/).filter((num) => num !== '').map((num) => {
          const id = parseInt(num, 36)
          return presets.onsets.find((item) => item.id === id)
        }).filter(isSafe)
      }),
      nuclea: nuclea.split('-').map((nucleus) => {
        return nucleus.split(/(.{2})/).filter((num) => num !== '').map((num) => {
          const id = parseInt(num, 36)
          return presets.nuclea.find((item) => item.id === id)
        }).filter(isSafe)
      }),
      codas: codas.split('-').map((coda) => {
        return coda.split(/(.{2})/).filter((num) => num !== '').map((num) => {
          const id = parseInt(num, 36)
          return presets.codas.find((item) => item.id === id)
        }).filter(isSafe)
      }),
    }
  }

  public generate () {
    this.words = uniqBy(sortBy(times(100, () => {
      const vocable = times(this.numOfSyllables, (index) => {
        return vocableToString(generateVocable({
          onsets: this.onsets[index].map(({ value }) => value),
          nuclea: this.nuclea[index].map(({ value }) => value),
          codas: this.codas[index].map(({ value }) => value),
          numOfSyllables: 1,
        }))
      }).join('')
      const sound: string = Onsya.parse(vocable).join('')
      return { vocable, sound }
    }), (word) => {
      return word.sound.split('').reverse().join('')
    }), (word) => {
      return word.sound
    })
  }

  public get filteredOnsets () {
    const onsets = presets.onsets.filter((onset) => onset.value.length <= this.onsetConsonantBlending)
    if (this.onsetQuery === '') {
      return onsets
    } else {
      return uniqBy(this.onsetQuery.split(' ').filter((query) => query !== '').flatMap((query) => {
        return onsets.filter((onset) => onset.key.startsWith(query))
      }), (coda) => coda.key)
    }
  }

  public get filteredNuclea () {
    if (this.nucleusQuery === '') {
      return presets.nuclea
    } else {
      return uniqBy(this.nucleusQuery.split(' ').filter((query) => query !== '').flatMap((query) => {
        return presets.nuclea.filter((nucleus) => nucleus.key.startsWith(query))
      }), (coda) => coda.key)
    }
  }

  public get filteredCodas () {
    const codas = presets.codas.filter((coda) => coda.value.length <= this.codaConsonantBlending)
    if (this.codaQuery === '') {
      return codas
    } else {
      return uniqBy(this.codaQuery.split(' ').filter((query) => query !== '').flatMap((query) => {
        return codas.filter((coda) => coda.key.startsWith(query))
      }), (coda) => coda.key)
    }
  }

  public handleSelectSyllable (selected: number) {
    this.activeIndex = selected - 1
  }

  public handleSelectOnset (selected: IItem) {
    if (!this.onsets[this.activeIndex].includes(selected)) {
      this.onsets[this.activeIndex].push(selected)
    }
  }

  public handleSelectNucleus (selected: IItem) {
    if (!this.onsets[this.activeIndex].includes(selected)) {
      this.nuclea[this.activeIndex].push(selected)
    }
  }

  public handleSelectCoda (selected: IItem) {
    if (!this.onsets[this.activeIndex].includes(selected)) {
      this.codas[this.activeIndex].push(selected)
    }
  }

  public handleRemoveOnset (onset: IItem, index: number) {
    this.onsets[index].splice(this.onsets[index].indexOf(onset), 1)
  }

  public handleRemoveNucleus (nucleus: IItem, index: number) {
    this.nuclea[index].splice(this.nuclea[index].indexOf(nucleus), 1)
  }

  public handleRemoveCoda (coda: IItem, index: number) {
    this.codas[index].splice(this.codas[index].indexOf(coda), 1)
  }

  public handleCopy (index: number) {
    this.copyContent = {
      onsets: [...this.onsets[index]],
      nuclea: [...this.nuclea[index]],
      codas: [...this.codas[index]],
    }
  }

  public handleCopyURL () {
    const url = document.querySelector('#url') as HTMLInputElement
    url.select()
    document.execCommand('copy')
  }

  public handleShare () {
    this.edit = false
    this.serialized = this.serialize(this.onsets, this.nuclea, this.codas, this.numOfSyllables)
  }

  public handleEdit () {
    this.edit = true
    this.words = []
  }

  public handlePaste (index: number) {
    if (!this.copyContent) {
      return
    }
    const {
      onsets,
      nuclea,
      codas,
    } = this.copyContent
    Vue.set(this.onsets, index, [...onsets])
    Vue.set(this.nuclea, index, [...nuclea])
    Vue.set(this.codas, index, [...codas])
  }

  public get presets () {
    return presets
  }

  public chunkBy<T> (items: T[], num: number) {
    return items.reduce((chunks, item, index) => {
      const key = Math.floor(index / num)
      chunks[key] = [...(chunks[key] || []), item]
      return chunks
    }, [] as T[][])
  }
}
